<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Admission(reservation) process</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмнэлэгт хэвтэх шийдвэр гарах, захиалга өгөх</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмнэлэгт хэвтэхээр бүртгүүлэх цаг болон өрөөний зэрэглэлийн SMS мессэжээр илгээнэ(хэвтэх өдөр)</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Бүртгүүлэх, тасагтаа хэвтэх</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Эмнэлэгт хэвтэх шийдвэр гарах, захиалга өгөх</h4>
            <p class="depth">Тасагт үзүүлсэн юм уу яаралтай тусламж авсны дараа эмнэлэгт хэвтүүлэхээр шийдвэрлэсэн бол эмчлэгч эмч нь эмнэлгийн цахим системд эмнэлэгт хэвтэх өдрийг оруулна.</p>
            <p class="depth">Өвчтөн болон асран хамгаалагч, Санхүүгийн албаны “Эмнэлэгт хэвтэх∙эмнэлгээс гарах”(яаралтай тусламжийн тасаг) бүртгэлийн цонхонд очиж бүртгэлээ хийлгэн захиалга өгнө.</p>
            <h4 class="depth bullet02">Эмнэлэгт хэвтэхээр бүртгүүлэх цаг болон өрөөний зэрэглэлийн SMS мессэжээр илгээнэ(хэвтэх өдөр)</h4>
            <p class="depth">
                Хэвтэх өрөө тодорхой болсны дараа мессэжээр эмнэлэгт хэвтэхээр бүртгүүлэх цаг болон өрөөний зэрэглэлийг мэдэгдэнэ. <br>
                Ямар өрөөнд хэвтэх нь тухайн өдрийн өрөөний хүртээмж, эмнэлгээс гарч байгаа өвчтөнүүдийн тоо зэргээс хамаарна. <br>
                Иймээс таны хүсэж буй өрөөний зэрэглэл тухайн өдөр хэвтэх боломжтой зэрэглэлтэй тохирохгүй байж болзошгүй.
            </p>
            <h4 class="depth bullet02">Бүртгүүлэх, тасагтаа хэвтэх</h4>
            <p class="depth">
                Эмнэлэгт хэвтэх заавар мессэж авсан өвчтөн заасан цагт асран хамгаалагчийн хамт эмнэлэгт ирээд, Санхүүгийн албаны “ Эмнэлэгт хэвтэх∙эмнэлгээс гарах” бүртгэлийн цонхноос хэвтэн эмчлүүлэх хүсэлтийн маягтыг авч бөглөнө. <br>
                Бүртгүүлсэн өвчтөн хуваарилсан өрөө байрлах тасаг руу очно. Тэнд хариуцсан сувилагч тосч аваад өрөөнд оруулна.
            </p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3">Эмнэлэгт хэвтэхэд шаардлагатай эд зүйлс</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="left">
                                гар нүүрийн хэрэгсэл, алчуур, аяга, таавчиг, нойлын цаас зэрэг хувийн хэрэглээний зүйл, сахиурын хөнжил дэвсгэр
                            </td>
                            <td class="left">
                                Эмнэлэгт хэвтэхийн өмнө ууж байсан эм(өөрт байгаа эм), Хэрэв эмнэлэгт хэвтэхээс өмнө ямар нэгэн эм ууж байсан бол эм болон эмийн жороо авчирна уу. <br>
                                Таны авчирсан эмийг ууж болох эсэхийг эмчлэгч эмч тань шийднэ. Өөрийн дураар ууж болохгүй. <br>
                                Шаардлагатай тохиолдолд эмнэлгээс бичиж өгсөн эмийг оронд нь ууж болно.
                            </td>
                            <td class="left">
                                Халдвар тархах, гал гарах зэрэг гэнэтийн ослоос урьдчилан сэргийлэхийн тулд агаар чийгшүүлэгч, ус буцалгагч, сэнс, халаадаг гудас зэрэг халдаг, шатамхай эд зүйл хэрэглэхийг хориглодог.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ Эмнэлэгт хэвтэх/гарах үед эмчийн магадлагаа, өвчтөний түүх, тодорхойлолт авах хүсэлтэй хүмүүс биеийн байцаалтаа өгнө үү. <br>
                (Харин 14-өөс доош настай бол түүний асран хамгаалагчийн биеийн байцаалт, садан төрлийн лавлагаа шаардлагатай.(иргэний үнэмлэхний лавлагаа, садан төрлийн лавлагаа))
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Эмнэлгээс гарах</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмнэлгээс гаргах шийдвэр</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмнэлгээс гарч буй өвчтөнд зориулсан сургалт</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Даатгалын шалгалт</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Эмнэлгийн төлбөр төлнө</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Гэрт уух эм олгох</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Эмнэлгээс гаргах шийдвэр</h4>
            <p class="depth ">Эмчлэгч эмч эмнэлгээс гарахын өмнөх өдөр юм уу тухайн өдөр эмнэлгээс гаргах шийдвэр гаргана.</p>
            <h4 class="depth bullet02 mt20">Эмнэлгээс гарч буй өвчтөнд зориулсан сургалт</h4>
            <p class="depth ">Амбулаторийн үзлэгийн/эмнэлэгт хэвтэх цаг захиалах болон эмнэлгээс гарсны дараах хөтөлбөрийг хариуцсан сувилагч тайлбарлаж өгөөд өвчтөний түүхийг бичиж цэгцэлнэ.</p>
            <h4 class="depth bullet02 mt20">Даатгалын шалгалт</h4>
            <p class="depth ">Өвчтөний түүхийг цэгцэлж дуусахад хянан шалгах багийнхан эмийн жор системд оруулахтай холбоотой даатгалын шалгалтыг хийнэ.</p>
            <h4 class="depth bullet02 mt20">Эмнэлгийн төлбөр төлнө</h4>
            <p class="depth ">Даатгалын хянан шалгах багийнхан шалгалт хийж дууссаны дараа өвчтөн болон асран хамгаалагчид нь мессэж илгээнэ. Мессэж мэдээллийн дагуу Санхүүгийн албаны “ Эмнэлэгт хэвтэх∙эмнэлгээс гарах” бүртгэлийн цонх болон тасагт байрлах автомат мөнгө хураагчинд(эмнэлэгт хэвтэх, гарах үед бүртгүүлдэг) очиж төлбөрөө төлнө.</p>
            <h4 class="depth bullet02 mt20">Гэрт уух эм олгох</h4>
            <p class="depth ">Эмнэлгийн төлбөр төлсний дараа хэвтэн эмчлүүлсэн тасгийн сувилагчаар гэр уух эм болон анхаарах зүйлийн талаар тайлбарлуулж аваад гэртээ харина.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Завсрын эмчилгээний төлбөрийн талаарх мэдээлэл</h3>
            <h4 class="depth bullet02">Завсрын эмчилгээний төлбөр шалгах болон төлөх</h4>
            <p class="depth">
                Завсрын эмчилгээний төлбөрийн мэдээллийг харах юм уу төлөх бол Санхүүгийн албаны “Бүртгэл∙төлбөр төлөх/Эмнэлэгт хэвтэх∙эмнэлгээс гарах” бүртгэлийн цонхонд очих буюу тасагт байрлах автомат мөнгө хураагч ашиглах боломжтой. Төлбөрийн мэдээлэл нь төлбөрийн мэдээлэл шалгаж байгаа тухайн өдрөөс нэг хоногийн өмнө оруулсан мэдээлэл(шалгаагүй) тул эмнэлгээс гарах үед төлөх төлбөрийн хэмжээнээс өөр байж болно.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>